import { render } from "./FooterContent.vue?vue&type=template&id=4f082296&scoped=true"
import script from "./FooterContent.vue?vue&type=script&lang=js"
export * from "./FooterContent.vue?vue&type=script&lang=js"

import "./FooterContent.vue?vue&type=style&index=0&id=4f082296&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f082296"]])

export default __exports__